/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InteraccionesPrincipiosActivosDto } from '../../models/interacciones-principios-activos-dto';

export interface DoctorPrincipiosActivosControllerGetInteraccionesPrincipiosActivos$Params {
}

export function doctorPrincipiosActivosControllerGetInteraccionesPrincipiosActivos(http: HttpClient, rootUrl: string, params?: DoctorPrincipiosActivosControllerGetInteraccionesPrincipiosActivos$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<InteraccionesPrincipiosActivosDto>>> {
  const rb = new RequestBuilder(rootUrl, doctorPrincipiosActivosControllerGetInteraccionesPrincipiosActivos.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<InteraccionesPrincipiosActivosDto>>;
    })
  );
}

doctorPrincipiosActivosControllerGetInteraccionesPrincipiosActivos.PATH = '/api/principios-activos/interacciones';
